import {
  resetFormState,
  updateRendererFormState,
} from "../../../slices/common/reducer";
import { setInformationDetailsData } from "../../../slices/hub/informationSlice";
import rootReducer from "../../../store";
import { showToast } from "../../../common/Toaster/Toaster";
import {
  setDrodownData,
  setSelectedUser,
} from "../../../slices/header/headerSlice";
import { getSwitchDropdown } from "../../../Utils/CommonService";
import api from "../../../Utils/interface";
import {
  setCertificateField,
  setInvoiceField,
} from "../../../slices/orders/orderSlice";

export const getData = async (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  await api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setInformationDetailsData(res.data));
      rootReducer.dispatch(updateRendererFormState(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

// export let updateInformation = async (
//   entity,
//   entityid,
//   entitytype,
//   navigator
// ) => {
//   const updatedEntity = {
//     ...entity,
//     entityid: entityid,
//     entitytype: entitytype,
//   };

//   let fd = new FormData();
//   fd.append("entityid", entityid);
//   fd.append("entitytype", updatedEntity.entitytype);
//   fd.append("entity", JSON.stringify(updatedEntity));

//   api
//     .post(`/entity/update`, fd, {})
//     .then((res) => {
//       rootReducer.dispatch(resetFormState());
//       rootReducer.dispatch(setSelectedUser(res.data));
//       rootReducer.dispatch(updateRendererFormState(res.data));
//       // const updatedDropdownData = getSwitchDropdown();
//       // rootReducer.dispatch(setDrodownData(updatedDropdownData));
//       // rootReducer.dispatch(setDrodownData(res.data));
//       navigator("/hub/information");
//       showToast("Information updated sucessfully", "success");
//     })
//     .catch((err) => {
//       showToast(err?.response?.data?.error_message, "error");
//     });
// };

export const updateInformation = async (
  entity,
  entityid,
  entitytype,
  navigator
) => {
  // List of keys to exclude
  const excludedKeys = [
    "code",
    "seq_no",
    "app_code",
    "buss_type",
    "buss_category",
    "buss_sub_category",
    "buss_desc",
    "buss_pan",
    "buss_name",
    "cin",
    "pan_owner_name",
    "authorised_signatory_pan",
    "billing_label",
    "billing_address",
    "billing_pincode",
    "billing_city",
    "billing_state",
    "gstin",
    "bankacc_benef_name",
    "bankacc_bank_name",
    "bankacc_acc_number",
    "bankacc_branch_ifsc",
    "auth_signatory_addproof",
    "aadhar_front_docid",
    "aadhar_back_docid",
    "buss_regproof_docid",
    "company_pan_docid",
    "logo_media_id", // Excluded from updatedEntity
    "icon_media_id",
    "icon_url",
    "logo_url",
    "files",
    "logo_media_id_name",
    "icon_media_id_name",
  ];

  // Prepare FormData
  const fd = new FormData();

  // Filter out the excluded keys from the entity for updatedEntity
  const updatedEntity = Object.keys(entity).reduce((acc, key) => {
    if (!excludedKeys.includes(key)) {
      acc[key] = entity[key];
    }
    return acc;
  }, {});

  // Add additional properties to updatedEntity
  updatedEntity.entityid = entityid;
  updatedEntity.entitytype = entitytype;

  fd.append("entityid", entityid);
  fd.append("entitytype", updatedEntity.entitytype);
  fd.append("entity", JSON.stringify(updatedEntity));

  const fileData = {};

  // Collect file data even if the key is in the excluded list (like logo_media_id)
  Object.keys(entity).forEach((key) => {
    if (entity[key] instanceof File || entity[key]?.type === "file") {
      fileData[key] = entity[key];
    }
  });

  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];
    if (file instanceof File) {
      fd.append(key, file);
    } else if (file?.type === "file") {
      fd.append(key, file.media_url);
    }
  });

  try {
    const response = await api.post(`/agsp/update`, fd);
    showToast("Information updated successfully", "success");
    window.location.reload();
    return response;
  } catch (error) {
    console.error("Error updating entity with files only", error);
    showToast("Error while updating", "error");
    throw error;
  }
};
